import React from "react";

const Password = () => {
  return (
    <div className="pt-12px">
      <div className="py-20px border-b md:gap-32px gap-16px border-primary-100 dark:border-accent-700 flex justify-between sm:flex-row flex-col">
        <div className="">
          <p className="text-primary-900 dark:text-accent-200 font-bold text-lg mb-1">
            Password
          </p>
          <p className="text-accent-400 dark:text-accent-300 m-0 mt-2 text-sm">
            Please enter your current to change your password
          </p>
        </div>
        <div className="flex gap-20px w-full sm:w-auto text-sm">
          <button className="w-full sm:w-auto py-10px px-20px rounded-lg font-medium text-accent-400 cursor-pointer bg-white border dark:bg-accent-800 dark:border-accent-600 border-accent-100 duration-300 h-fit hover:opacity-90">
            Cancel
          </button>
          <button
            className="w-full sm:w-auto py-10px px-20px rounded-lg font-medium text-white cursor-pointer bg-primary-500 border-0 duration-300 h-fit disabled:opacity-50 hover:opacity-90 disabled:hover:opacity-50 disabled:bg-accent-200 dark:disabled:bg-accent-600"
            disabled
          >
            Change
          </button>
        </div>
      </div>
      <div className="py-20px border-b md:gap-32px gap-16px border-primary-100 dark:border-accent-700 flex justify-between sm:flex-row flex-col">
        <div className="flex md:gap-32px gap-10px max-w-[1100px] justify-between w-full sm:flex-row flex-col">
          <label
            className="text-accent-400 dark:text-accent-300 m-0 text-sm font-medium"
            htmlFor="current-password"
          >
            Current password
          </label>
          <div className="focus-within:outline focus-within:outline-primary-500 dark:bg-accent-800 dark:border-none focus-within:border-transparent flex sm:max-w-[512px] w-full bg-white font-medium m-0 box-border rounded-lg border border-accent-100 outline-none shadow-sm overflow-hidden">
            <div className="flex items-center px-3">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 10V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V10M12 14.5V16.5M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C17.7202 10 16.8802 10 15.2 10H8.8C7.11984 10 6.27976 10 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z"
                  className="stroke-accent-400"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <input
              className="h-full w-full text-primary-900 dark:text-accent-200 bg-transparent py-12px px-16px border-none outline-none box-border font-semibold"
              autoComplete="off"
              type="text"
              placeholder="••••••••••••"
              id="current-password"
            />
          </div>
        </div>
      </div>
      <div className="py-20px border-b md:gap-32px gap-16px border-primary-100 dark:border-accent-700 flex justify-between sm:flex-row flex-col">
        <div className="flex md:gap-32px gap-10px max-w-[1100px] justify-between w-full sm:flex-row flex-col">
          <label
            className="text-accent-400 dark:text-accent-300 m-0 text-sm font-medium"
            htmlFor="new-password"
          >
            New password
          </label>
          <div className="focus-within:outline focus-within:outline-2 focus-within:outline-primary-500 focus-within:border-white flex sm:max-w-[512px] w-full bg-white dark:bg-accent-800 dark:border-none font-medium m-0 box-border rounded-lg border border-accent-100 outline-none shadow-sm overflow-hidden">
            <div className="flex items-center px-3">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.5 13L7.28446 14.5689C7.54995 15.0999 7.68269 15.3654 7.86003 15.5954C8.01739 15.7996 8.20041 15.9826 8.40455 16.14C8.63462 16.3173 8.9001 16.4501 9.43108 16.7155L11 17.5L9.43108 18.2845C8.9001 18.5499 8.63462 18.6827 8.40455 18.86C8.20041 19.0174 8.01739 19.2004 7.86003 19.4046C7.68269 19.6346 7.54995 19.9001 7.28446 20.4311L6.5 22L5.71554 20.4311C5.45005 19.9001 5.31731 19.6346 5.13997 19.4046C4.98261 19.2004 4.79959 19.0174 4.59545 18.86C4.36538 18.6827 4.0999 18.5499 3.56892 18.2845L2 17.5L3.56892 16.7155C4.0999 16.4501 4.36538 16.3173 4.59545 16.14C4.79959 15.9826 4.98261 15.7996 5.13997 15.5954C5.31731 15.3654 5.45005 15.0999 5.71554 14.5689L6.5 13Z"
                  className="stroke-accent-400"
                  strokeWidth="1.7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15 2L16.1786 5.06442C16.4606 5.79765 16.6016 6.16426 16.8209 6.47264C17.0153 6.74595 17.254 6.98475 17.5274 7.17909C17.8357 7.39836 18.2024 7.53937 18.9356 7.82138L22 9L18.9356 10.1786C18.2024 10.4606 17.8357 10.6016 17.5274 10.8209C17.254 11.0153 17.0153 11.254 16.8209 11.5274C16.6016 11.8357 16.4606 12.2024 16.1786 12.9356L15 16L13.8214 12.9356C13.5394 12.2024 13.3984 11.8357 13.1791 11.5274C12.9847 11.254 12.746 11.0153 12.4726 10.8209C12.1643 10.6016 11.7976 10.4606 11.0644 10.1786L8 9L11.0644 7.82138C11.7976 7.53937 12.1643 7.39836 12.4726 7.17909C12.746 6.98475 12.9847 6.74595 13.1791 6.47264C13.3984 6.16426 13.5394 5.79765 13.8214 5.06442L15 2Z"
                  className="stroke-accent-400"
                  strokeWidth="1.7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <input
              className="h-full w-full text-primary-900 dark:text-accent-200 bg-transparent py-12px px-16px border-none outline-none box-border font-semibold"
              autoComplete="off"
              type="text"
              placeholder="••••••••••••"
              id="new-password"
            />
          </div>
        </div>
      </div>
      <div className="py-20px border-b md:gap-32px gap-16px border-primary-100 dark:border-accent-700 flex justify-between sm:flex-row flex-col">
        <div className="flex md:gap-32px gap-10px max-w-[1100px] justify-between w-full sm:flex-row flex-col">
          <label
            className="text-accent-400 dark:text-accent-300 m-0 text-sm font-medium"
            htmlFor="confirm-new-password"
          >
            Confirm new password
          </label>
          <div className="focus-within:outline focus-within:outline-primary-500 dark:bg-accent-800 dark:border-none focus-within:border-transparent flex sm:max-w-[512px] w-full bg-white font-medium m-0 box-border rounded-lg border border-accent-100 outline-none shadow-sm overflow-hidden">
            <div className="flex items-center px-3">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.5 13L7.28446 14.5689C7.54995 15.0999 7.68269 15.3654 7.86003 15.5954C8.01739 15.7996 8.20041 15.9826 8.40455 16.14C8.63462 16.3173 8.9001 16.4501 9.43108 16.7155L11 17.5L9.43108 18.2845C8.9001 18.5499 8.63462 18.6827 8.40455 18.86C8.20041 19.0174 8.01739 19.2004 7.86003 19.4046C7.68269 19.6346 7.54995 19.9001 7.28446 20.4311L6.5 22L5.71554 20.4311C5.45005 19.9001 5.31731 19.6346 5.13997 19.4046C4.98261 19.2004 4.79959 19.0174 4.59545 18.86C4.36538 18.6827 4.0999 18.5499 3.56892 18.2845L2 17.5L3.56892 16.7155C4.0999 16.4501 4.36538 16.3173 4.59545 16.14C4.79959 15.9826 4.98261 15.7996 5.13997 15.5954C5.31731 15.3654 5.45005 15.0999 5.71554 14.5689L6.5 13Z"
                  className="stroke-accent-400"
                  strokeWidth="1.7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15 2L16.1786 5.06442C16.4606 5.79765 16.6016 6.16426 16.8209 6.47264C17.0153 6.74595 17.254 6.98475 17.5274 7.17909C17.8357 7.39836 18.2024 7.53937 18.9356 7.82138L22 9L18.9356 10.1786C18.2024 10.4606 17.8357 10.6016 17.5274 10.8209C17.254 11.0153 17.0153 11.254 16.8209 11.5274C16.6016 11.8357 16.4606 12.2024 16.1786 12.9356L15 16L13.8214 12.9356C13.5394 12.2024 13.3984 11.8357 13.1791 11.5274C12.9847 11.254 12.746 11.0153 12.4726 10.8209C12.1643 10.6016 11.7976 10.4606 11.0644 10.1786L8 9L11.0644 7.82138C11.7976 7.53937 12.1643 7.39836 12.4726 7.17909C12.746 6.98475 12.9847 6.74595 13.1791 6.47264C13.3984 6.16426 13.5394 5.79765 13.8214 5.06442L15 2Z"
                  className="stroke-accent-400"
                  strokeWidth="1.7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <input
              className="h-full w-full text-primary-900 dark:text-accent-200 bg-transparent py-12px px-16px border-none outline-none box-border font-semibold"
              autoComplete="off"
              type="text"
              placeholder="••••••••••••"
              id="confirm-new-password"
            />
          </div>
        </div>
      </div>
      <div className="py-20px md:gap-32px gap-16p flex justify-between sm:flex dark:border-accent-700-row flex-col">
        <div className="">
          <p className="text-primary-900 dark:text-accent-200 font-bold text-lg mb-1">
            Where you’re logged in
          </p>
          <p className="text-accent-400 dark:text-accent-300 m-0 mt-2 text-sm">
            We’ll alert you via <strong>jadamohameed@gmail.com</strong> if there
            in unusual on tour account
          </p>
        </div>
      </div>
    </div>
  );
};
export default Password;
